import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiService from "../services/apiService"; // adjust path as needed
import { format } from "date-fns";

type UsePaginatedFetchProps = {
  endpoint: string;
  pageSize?: number;
  transform?: (data: any[]) => any[];
  initialSearchQuery?:string;
  filterOn?:string,
  sortBy?:string,
  enabled?:boolean,
  refreshKey?:number
};
const endDate = new Date();
const startDate = new Date();
startDate.setDate(startDate.getDate() - 6);
startDate.setHours(0, 0, 0, 0);


export const usePagination = ({ endpoint, pageSize = 10, transform,initialSearchQuery,filterOn,sortBy,enabled,refreshKey }: UsePaginatedFetchProps) => {
  const [data, setData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const[sort,setSortBy] = useState<string>('')
  const [fromDate, setFromDate] = useState<any>(startDate);  // ✅ default 7 days ago
  const [toDate, setToDate] = useState<any>(endDate);   
  const[searchQuery,setSearchQuery] = useState<string>(initialSearchQuery||'')
  const[id,setId] = useState(null)
  const[pumpingStationId,setPumpingStationId] = useState<number|string>()
  const [schemeVillageId,setSchemeVillageId] = useState<number|string>()
  const [deviceType,setDeviceType] = useState<string>()
  const[WuaId,setWauId] = useState<string>()
  const[reportType,setReportType] = useState<string>('')
  const [kml,setKml] = useState<number>(1)
  
  const fetchData = async () => {
    setLoading(true);
    try {
        
      const response = await ApiService.axiosApi(endpoint, {
        method: "GET",
        params: { pageNumber,
           pageSize,
           filterOn,
           filterQuery:searchQuery || null,
           sortBy:sort||null,
           isAssending: true,
           fromDate: fromDate ? format(new Date(fromDate), "yyyy-MM-dd HH:mm:ss") : null,  // ✅
           toDate: toDate ? format(new Date(toDate), "yyyy-MM-dd HH:mm:ss") : null,        // ✅
           chakId:id,
           pumpingStationId:pumpingStationId,
           schemeVillageId:schemeVillageId,
           DeviceType:deviceType,
           WuaId:WuaId,
           ReportType:reportType
         },
        
      });
    
      if (response.success) {
       
        const items = transform ? transform(response.data.data) : response.data.data;
        setData(items);
        setTotalCount(response.data.totalCount)
       
        // adjust based on your backend
        
      } else {
        toast.error( response.data );
      }
    } catch (err: any) {
      toast.error(err.status || "Fetch error");
    } finally {
      setLoading(false);
    }
  
  };

  useEffect(() => {
    if(enabled){
    fetchData();
    }
  }, [pageNumber, refresh, endpoint, pageSize,searchQuery,sort,enabled,refreshKey,deviceType,kml]);

  return {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    loading,
    searchQuery,
    setSearchQuery,
    filterOn,
    setSortBy,
    setFromDate,
    setToDate,
    setId,
    id,
    fromDate,
    toDate,
    setPumpingStationId,
    setData,
    setSchemeVillageId,
    setDeviceType,
    deviceType,
    setWauId,
    setReportType,
    setKml
  };
};
